/*
  Shared helpers for the Sweet Shop theme (ported from the Pink Pouch demo).
  Exposes window.SweetShop = { pouch, swatch, money, esc, hydratePouches, PALETTE,
                              cleanTitle, shortTitle, packageInfo, TYPE_ORDER }.

  Pouches are decorative SVGs. Liquid can't do the random-looking candy layout (no sin()),
  so sections output a placeholder and this file draws into it:

    <span data-pouch='{"fill":0.7,"seed":3,"w":120,"aria":"1 LB Bag"}'></span>

  Options: colors (array of hex), fill (0–1), seed, max (candy count when full), r (candy radius),
  w (width in px), label (false hides the round label), name (text on the label), aria,
  lb (weight in pounds: sets w/max/r so pouches are drawn to scale),
  shape (bag | salad | bucket | platter | snackle; see SHAPES).

  Also fills <span data-swatch-name="Peach Rings"> gumdrop dots that have no inline background.
*/
(function () {
  var PALETTE = ['#E8485A', '#4F9BD9', '#F3D35B', '#7CBF4A', '#F48FB1', '#F28C38', '#B98EE0'];

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Shopify prices are in cents. window.theme.moneyFormat comes from the shop's settings
  // (e.g. "${{amount}}"), so currency and formatting stay owner-controlled.
  function money(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (Number(cents) || 0) / 100;
    function withDelimiters(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  /* ---------- Titles + package info from the store's real product titles ----------
     The store's titles carry merchandising text, e.g.
       "**Featured** Sweet Shuffle 1 1/2 LB Bag Choose up to 10 Sweets!"
     cleanTitle() → "Sweet Shuffle 1½ LB Bag"; shortTitle() also drops brand prefixes → "1½ LB Bag".
     snippets/clean-title.liquid does the same on the server; keep the two in step. */
  function cleanTitle(t) {
    return String(t || '')
      .replace(/\*\*\s*featured\s*\*\*/gi, '')
      .replace(/\*\s*holiday\s*\*/gi, '')
      .replace(/[.,]?\s*choose up to \d+ sweets!*/gi, '')
      .replace(/!/g, '')
      .replace(/\s+of (your favorite )?sweets\b/gi, '')
      .replace(/\b(\d+) 1\/2\b/g, '$1½')
      .replace(/\b1\/2\b/g, '½')
      .replace(/\b3\/4\b/g, '¾')
      .replace(/\s+/g, ' ')
      .trim();
  }
  function shortTitle(t) {
    var s = cleanTitle(t).replace(/^(sweet shop curated shuffle -|sweet shop curated -|sweet shop curated,|sweet shop curated|sweet shop's|sweet shuffle)\s+/i, '');
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  // Pick limit by weight, matching the live store's sizes (½ LB → 5 … 50 LB → 100).
  function limitForWeight(lb) {
    var table = [[0.75, 5], [1.5, 10], [3, 15], [4, 20], [5, 25], [10, 40], [25, 65], [40, 80]];
    for (var i = 0; i < table.length; i++) if (lb <= table[i][0]) return table[i][1];
    return 100;
  }

  // Weight, pick limit and tab for a package. Metafields win; otherwise read the title.
  //   meta = { limit, lb, type } from custom.pick_limit / custom.weight_lb / Product type (any may be empty)
  //   meta.handle: looks up the "Pick limit overrides" theme setting (window.theme.pickLimits).
  function packageInfo(title, meta) {
    meta = meta || {};
    var overrides = (window.theme && window.theme.pickLimits) || {};
    if (!parseInt(meta.limit, 10) && meta.handle && overrides[meta.handle]) meta.limit = overrides[meta.handle];
    var t = String(title || '');
    var lb = parseFloat(meta.lb) || null;
    if (!lb) {
      var m = t.match(/(?:(\d+)\s+)?(\d+)\/(\d+)\s*lbs?\b/i);
      if (m) lb = (m[1] ? +m[1] : 0) + m[2] / m[3];
      else if ((m = t.match(/(\d+(?:\.\d+)?)\s*lbs?\b/i))) lb = parseFloat(m[1]);
    }
    var limit = parseInt(meta.limit, 10) || null;
    if (!limit) {
      var u = t.match(/up to (\d+)/i);
      limit = u ? +u[1] : limitForWeight(lb || 1);
    }
    var type = meta.type;
    if (!type) {
      if (/\*\s*holiday\s*\*|christmas|snow ?globe|snowman|frosty/i.test(t)) type = 'Christmas';
      else if (/halloween|skull|coffin|jar|pumpkin|witch|ghost|widow|party favor/i.test(t)) type = 'Halloween';
      else if (/salad/i.test(t)) type = 'Candy Salads';
      else if (/bucket/i.test(t)) type = 'Buckets';
      else if (/platter|snackle/i.test(t)) type = 'Platters & Snackles';
      else if (/bag/i.test(t)) type = 'Bags';
      else type = 'More';
    }
    return { lb: lb || 1, limit: limit, type: type };
  }
  // 1.5 → "1½", 0.75 → "¾", 2.5 → "2½", 3 → "3"
  function formatLb(lb) {
    var whole = Math.floor(lb), frac = { 0.25: '¼', 0.5: '½', 0.75: '¾' }[Math.round((lb - whole) * 100) / 100];
    if (frac) return (whole || '') + frac;
    return String(Math.round(lb * 100) / 100);
  }
  var TYPE_ORDER = ['Bags', 'Candy Salads', 'Buckets', 'Platters & Snackles', 'Christmas', 'Halloween', 'More'];

  // Gumdrop color for a sweet. Products can set custom.swatch; otherwise guess from the name.
  var SWATCH_WORDS = [
    ['blue', '#4F9BD9'], ['cola', '#8A5530'], ['grape', '#8E5BB5'], ['lime', '#6DB33F'], ['apple', '#7CBF4A'],
    ['kiwi', '#6DB33F'], ['pickle', '#6E9B3A'], ['pear', '#B6CC4A'], ['avocado', '#7E9B3E'], ['gator', '#5E9E45'],
    ['frog', '#5E9E45'], ['watermelon', '#F0687C'], ['cherry', '#C42B45'], ['strawberry', '#E8485A'],
    ['rasp', '#D6457A'], ['pink', '#F29BB5'], ['cotton', '#F6B5D0'], ['peach', '#F7A66B'], ['mango', '#F5A13C'],
    ['orange', '#F28C38'], ['creamsicle', '#F6B26B'], ['lemon', '#F2D244'], ['banana', '#F3D35B'],
    ['pine', '#F0C93F'], ['egg', '#F7D774'], ['candy corn', '#F3A43B'], ['licorice', '#3A2A2A'],
    ['shark', '#5A8FC9'], ['whale', '#5A8FC9'], ['fish', '#E0544F'], ['bubblegum', '#F59AC4'], ['neon', '#9BE15D'],
    ['champagne', '#F1DFA3'], ['coconut', '#EDE6D6'], ['skull', '#E3D7EC'], ['bones', '#E9E1D2'],
    ['rainbow', '#B98EE0'], ['tutti', '#F48FB1']
  ];
  function swatch(name) {
    var n = String(name).toLowerCase();
    for (var i = 0; i < SWATCH_WORDS.length; i++) {
      if (n.indexOf(SWATCH_WORDS[i][0]) !== -1) return SWATCH_WORDS[i][1];
    }
    var pal = ['#F7A1B5', '#F6C85F', '#8FD3C6', '#B7A3E3', '#F49A6B', '#9FD27E'];
    var h = 0;
    for (var j = 0; j < n.length; j++) h = (h * 31 + n.charCodeAt(j)) % 997;
    return pal[h % pal.length];
  }

  // Deterministic "random" so a pouch looks the same on every render.
  function rnd(s) {
    var x = Math.sin(s * 9301 + 49297) * 233280;
    return x - Math.floor(x);
  }

  // Stand-up pouch in SVG; candy fills from the bottom, the round label shows a name.
  var pid = 0;
  /* Container shapes, all in the bag's style (dark outline, pink fill with candy, white shine, round label).
     Each draws in the same 200×262 box resting on the same baseline, so they line up in a size row.
       clip:   the inside the candy fills (path d, or an <ellipse>)
       region: where candy dots go {x0, x1, yb (bottom), yt (top when full)}
       back / front: SVG drawn under / over the candy;  shine: highlight path;  label: {cx, cy, r} */
  var INK = 'stroke="#1E0F0F" stroke-width="3"';
  var SHAPES = {
    bag: (function () {
      var d = 'M32 18 H168 Q176 18 176 26 L183 226 Q185 252 160 254 H40 Q15 252 17 226 L24 26 Q24 18 32 18 Z';
      return {
        clip: '<path d="' + d + '"/>',
        back: '<path d="' + d + '" fill="#FFC9D7"/>',
        region: { x0: 24, x1: 176, yb: 246, yt: 46 },
        shine: 'M40 30 Q36 140 44 230',
        front: '<path d="' + d + '" fill="none" ' + INK + '/>' +
          '<path d="M26 40 H174" stroke="#1E0F0F" stroke-width="2" stroke-dasharray="5 4"/>' +
          '<path d="M30 254 Q100 238 170 254" stroke="#1E0F0F" stroke-width="2" fill="none" opacity=".35"/>',
        label: { cx: 100, cy: 148, r: 44 }
      };
    })(),
    // Candy salad: a clear round tub with a snap-on lid.
    salad: (function () {
      var d = 'M24 128 H176 L169 234 Q167 250 150 250 H50 Q33 250 31 234 Z';
      return {
        clip: '<path d="' + d + '"/>',
        back: '<path d="' + d + '" fill="#FFC9D7"/>',
        region: { x0: 28, x1: 172, yb: 246, yt: 134 },
        shine: 'M40 140 Q38 192 46 238',
        front: '<path d="' + d + '" fill="none" ' + INK + '/>' +
          '<rect x="14" y="106" width="172" height="25" rx="10" fill="#FFC9D7" ' + INK + '/>' +
          '<path d="M28 114 H172" stroke="#FFFFFF" stroke-width="4" stroke-linecap="round" opacity=".6"/>' +
          '<path d="M40 250 Q100 240 160 250" stroke="#1E0F0F" stroke-width="2" fill="none" opacity=".35"/>',
        label: { cx: 100, cy: 190, r: 34 }
      };
    })(),
    // Bucket: a pail with a rim and a wire handle.
    bucket: (function () {
      var d = 'M32 100 H168 L157 242 Q156 252 146 252 H54 Q44 252 43 242 Z';
      return {
        clip: '<path d="' + d + '"/>',
        back: '<path d="M32 100 C32 26 168 26 168 100" fill="none" ' + INK + '/>' + '<path d="' + d + '" fill="#FFC9D7"/>',
        region: { x0: 36, x1: 164, yb: 248, yt: 108 },
        shine: 'M48 114 Q46 182 56 238',
        front: '<path d="' + d + '" fill="none" ' + INK + '/>' +
          '<rect x="24" y="90" width="152" height="18" rx="7" fill="#FFC9D7" ' + INK + '/>' +
          '<circle cx="32" cy="99" r="4.5" fill="#FEFBF0" stroke="#1E0F0F" stroke-width="2"/>' +
          '<circle cx="168" cy="99" r="4.5" fill="#FEFBF0" stroke="#1E0F0F" stroke-width="2"/>' +
          '<path d="M46 252 Q100 242 154 252" stroke="#1E0F0F" stroke-width="2" fill="none" opacity=".35"/>',
        label: { cx: 100, cy: 178, r: 38 }
      };
    })(),
    // Platter: a round sectioned tray seen from the front, with a hub label in the middle.
    platter: (function () {
      var cx = 100, cy = 198, rx = 90, ry = 38, spokes = '';
      for (var a = 0; a < 6; a++) {
        var t = (a * 60 + 30) * Math.PI / 180;
        spokes += '<path d="M' + cx + ' ' + cy + ' L' + (cx + rx * Math.cos(t)).toFixed(1) + ' ' + (cy + ry * Math.sin(t)).toFixed(1) +
          '" stroke="#1E0F0F" stroke-width="2.5"/>';
      }
      return {
        clip: '<ellipse cx="' + cx + '" cy="' + cy + '" rx="' + rx + '" ry="' + ry + '"/>',
        back: '<path d="M10 198 V216 A90 38 0 0 0 190 216 V198" fill="#FFC9D7" ' + INK + '/>',
        region: { x0: 14, x1: 186, yb: 232, yt: 160 },
        shine: 'M30 186 Q60 166 104 162',
        front: '<ellipse cx="' + cx + '" cy="' + cy + '" rx="' + rx + '" ry="' + ry + '" fill="none" ' + INK + '/>' + spokes +
          '<path d="M40 252 Q100 246 160 252" stroke="#1E0F0F" stroke-width="2" fill="none" opacity=".25"/>',
        label: { cx: 100, cy: 198, r: 24 }
      };
    })(),
    // Snackle: a clear tackle-box style case with compartments and a handle.
    snackle: (function () {
      var d = 'M28 120 H172 Q184 120 184 132 V238 Q184 250 172 250 H28 Q16 250 16 238 V132 Q16 120 28 120 Z';
      return {
        clip: '<path d="' + d + '"/>',
        back: '<path d="M74 120 V104 Q74 95 83 95 H117 Q126 95 126 104 V120" fill="none" ' + INK + '/>' + '<path d="' + d + '" fill="#FFC9D7"/>',
        region: { x0: 20, x1: 180, yb: 246, yt: 142 },
        shine: 'M30 146 Q28 196 34 240',
        front: '<path d="' + d + '" fill="none" ' + INK + '/>' +
          '<path d="M16 138 H184" stroke="#1E0F0F" stroke-width="2.5"/>' +
          '<path d="M72 140 V248 M128 140 V248 M18 194 H182" stroke="#1E0F0F" stroke-width="2" opacity=".55"/>' +
          '<rect x="38" y="132" width="14" height="10" rx="3" fill="#FEFBF0" stroke="#1E0F0F" stroke-width="2"/>' +
          '<rect x="148" y="132" width="14" height="10" rx="3" fill="#FEFBF0" stroke="#1E0F0F" stroke-width="2"/>',
        label: { cx: 100, cy: 194, r: 30 }
      };
    })()
  };

  // Which drawing to use for a package, from its tab and title.
  function shapeFor(type, title) {
    var t = String(title || '');
    if (type === 'Candy Salads' || /salad/i.test(t)) return 'salad';
    if (type === 'Buckets' || /bucket/i.test(t)) return 'bucket';
    if (/snackle/i.test(t)) return 'snackle';
    if (type === 'Platters & Snackles' || /platter/i.test(t)) return 'platter';
    return 'bag';
  }

  function labelSVG(L, name) {
    var k = L.r / 44;
    var nameSize = (name && name.length > 8 ? Math.max(13, 26 - (name.length - 8) * 1.4) : 30) * k;
    var y = function (dy) { return (L.cy + dy * k).toFixed(1); };
    var font = 'font-family="Playfair Display, Georgia, serif" font-weight="700"';
    return '<circle cx="' + L.cx + '" cy="' + L.cy + '" r="' + L.r + '" fill="#FEFBF0" stroke="#AB3939" stroke-width="' + (3 * k).toFixed(1) + '"/>' +
      '<circle cx="' + L.cx + '" cy="' + L.cy + '" r="' + (L.r - 6 * k).toFixed(1) + '" fill="none" stroke="#FFDDE6" stroke-width="' + (2 * k).toFixed(1) + '"/>' +
      '<text x="' + L.cx + '" y="' + y(-20) + '" text-anchor="middle" ' + font + ' font-size="' + (8 * k).toFixed(1) + '" letter-spacing="' + (2.4 * k).toFixed(1) + '" fill="#B62424">THE</text>' +
      '<text x="' + L.cx + '" y="' + y(8) + '" text-anchor="middle" font-family="Pinyon Script, cursive" font-size="' + nameSize.toFixed(1) + '" fill="#B62424">' + esc(name || 'Sweet') + '</text>' +
      '<text x="' + L.cx + '" y="' + y(24) + '" text-anchor="middle" ' + font + ' font-size="' + (7.5 * k).toFixed(1) + '" letter-spacing="' + (1.6 * k).toFixed(1) + '" fill="#B62424">' + (name ? 'SWEET SHOP' : 'SHOP CANDY') + '</text>';
  }

  // A container drawn in SVG; candy fills from the bottom. o.shape: bag (default) | salad | bucket | platter | snackle.
  function pouch(colors, pct, o) {
    o = o || {};
    var sh = SHAPES[o.shape] || SHAPES.bag, R = sh.region;
    var id = 'pc' + ++pid;
    var max = o.max || 120, seed = o.seed || 1, r = o.r || 7;
    var fill = Math.max(0, Math.min(1, pct));
    var n = colors.length ? Math.round(max * fill) : 0;
    var dots = '';
    for (var i = 0; i < n; i++) {
      var f = i / max;
      var cy = R.yb - (R.yb - R.yt) * f * (0.94 + 0.06 * rnd(seed + i * 2.3)) - rnd(seed + i) * 8;
      var cx = R.x0 + rnd(seed + i * 5.7) * (R.x1 - R.x0);
      var rr = r * (0.75 + rnd(seed + i * 3.3) * 0.5);
      dots += '<ellipse cx="' + cx.toFixed(1) + '" cy="' + cy.toFixed(1) + '" rx="' + rr.toFixed(1) + '" ry="' +
        (rr * 0.85).toFixed(1) + '" fill="' + colors[i % colors.length] + '" transform="rotate(' +
        Math.round(rnd(seed + i * 9) * 180) + ' ' + cx.toFixed(1) + ' ' + cy.toFixed(1) + ')"/>';
    }
    var aria = o.aria === '' ? ' aria-hidden="true"' : ' role="img" aria-label="' + esc(o.aria || 'Candy pouch') + '"';
    return '<svg class="pouch" viewBox="0 0 200 262"' + aria + (o.w ? ' style="width:' + o.w + 'px"' : '') + '>' +
      '<defs><clipPath id="' + id + '">' + sh.clip + '</clipPath></defs>' +
      sh.back +
      '<g clip-path="url(#' + id + ')"><rect x="0" y="0" width="200" height="262" fill="#FFDDE6"/>' + dots +
      '<rect x="0" y="0" width="200" height="262" fill="#FFFFFF" opacity=".18"/>' +
      '<path d="' + sh.shine + '" stroke="#FFFFFF" stroke-width="8" stroke-linecap="round" opacity=".5" fill="none"/></g>' +
      sh.front +
      (o.label === false ? '' : labelSVG(sh.label, o.name)) + '</svg>';
  }

  // Draw every [data-pouch] placeholder inside `root` (defaults to the whole page).
  function hydratePouches(root) {
    (root || document).querySelectorAll('[data-pouch]').forEach(function (el) {
      var o;
      try { o = JSON.parse(el.getAttribute('data-pouch') || '{}'); } catch (e) { o = {}; }
      var colors = o.colors && o.colors.length ? o.colors : PALETTE;
      // "lb": size the pouch to scale from its weight (bigger bags draw bigger, by area).
      if (o.lb) {
        var w = Math.min(o.wmax || 230, Math.round(54 + Math.sqrt(o.lb) * 30));
        o.w = w;
        o.max = Math.round(40 + w / 3);
        o.r = Math.max(4, w / 28);
        if (w <= 90) o.label = false;
      }
      el.innerHTML = pouch(colors, o.fill == null ? 0.7 : o.fill, o);
      el.removeAttribute('data-pouch');
    });
    // Gumdrop dots with no custom.swatch color get one guessed from the sweet's name.
    (root || document).querySelectorAll('[data-swatch-name]').forEach(function (el) {
      if (!el.style.background) el.style.background = swatch(el.getAttribute('data-swatch-name'));
      el.removeAttribute('data-swatch-name');
    });
  }

  window.SweetShop = {
    pouch: pouch, swatch: swatch, money: money, esc: esc, hydratePouches: hydratePouches, PALETTE: PALETTE,
    cleanTitle: cleanTitle, shortTitle: shortTitle, packageInfo: packageInfo, formatLb: formatLb, TYPE_ORDER: TYPE_ORDER,
    shapeFor: shapeFor
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hydratePouches(); });
  } else {
    hydratePouches();
  }
  // Theme editor: re-draw when a section is added or re-rendered.
  document.addEventListener('shopify:section:load', function (e) { hydratePouches(e.target); });
})();
